import React from "react";
import styled from "styled-components";
import { BsCheckLg } from "react-icons/bs";

const Newsletter = () => {
  return (
    <NewsletterMain>
      <NewsletterContianer>
        <h2>We are 24/7 Available for your need</h2>
        <p>Start your project today with the best development team</p>
        <div className="inputNews">
          <input type="text" placeholder="Enter your email address" />
          <div className="getStarted">Get started</div>
        </div>
        <div className="checkBox">
          <li>
            <div>
              <BsCheckLg className="check" />
            </div>
            Free 14-day Demo
          </li>
          <li>
            <div>
              <BsCheckLg className="check" />
            </div>
            No credit card needed
          </li>
          <li>
            <div>
              <BsCheckLg className="check" />
            </div>
            No Setup
          </li>
        </div>
      </NewsletterContianer>
    </NewsletterMain>
  );
};

export default Newsletter;

const NewsletterMain = styled.div`
  padding: 4rem calc((100vw - 1200px) / 2);

  @media only screen and (max-width: 991px) {
    padding: 2rem calc((100vw - 1200px) / 2);
  }
`;

const NewsletterContianer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  background: #d6eaff;
  background: linear-gradient(135deg, #d6eaff, #c0ffbd);
  padding: 70px 20px;
  border-radius: 7px;

  h2 {
    font-size: 28px;
    font-weight: 500;
    color: #20204f;
  }
  p {
    font-size: 15px;
    font-weight: 500;
    color: #535353;
    margin-top: 10px;
  }
  .inputNews {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
    input {
      width: 350px;
      padding: 15px 25px;
      border: none;
      outline: none;
      border-radius: 20px;
      color: #20204f;
      font-weight: 500;
    }
    .getStarted {
      margin-left: -25px;
      background-color: #20204f;
      padding: 12.5px 25px;
      border-radius: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
  .checkBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    list-style: none;
    li {
      color: grey;
      margin: 0px 10px;
      font-size: 15px;
      display: flex;
      color: #20204f;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #cfd3ff;
        border: 2px solid #20204f;
        height: 22px;
        width: 22px;
        border-radius: 50%;
        margin-right: 7px;

        .check {
          font-size: 16px;
          color: #20204f;
        }
      }
    }
  }

  @media only screen and (max-width: 991px) {
    padding: 30px 0px;
    margin: 10px;

    h2 {
      text-align: center;
    }
    p {
      text-align: center;
    }
    .inputNews {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 25px;

      input {
        width: 330px;
      }
      .getStarted {
        margin-left: 0px;
        background-color: #20204f;
        padding: 12.5px 25px;
        border-radius: 20px;
        color: #fff;
        cursor: pointer;
        margin-top: 1rem;
      }
    }
    .checkBox {
      align-items: flex-start;
      flex-direction: column;
      margin-top: 20px;
      li {
        font-size: 18px;
        margin-bottom: 1.2rem;
      }
    }
  }
`;
